import React, { useEffect, useState } from "react";
import Avatar from '@mui/material/Avatar';
import { ButtonStyleAzul, ButtonStyleVerde, COLOR_BACKGROUND_WHITE_CLARO, CssTextField, DivBackgroundDasboard, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../styles/Styles";
import { LogoSicoop } from '../components/logos/LogoImg';
import { LinearProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SplashIcon = () => {
    let nameLocal = localStorage.getItem('dataUser');
    //---------------------------------ruta de redireccion
    let history = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            if (!nameLocal) {
                history('/login');
            }
        }, 2000);
    }, []);



    return (
            <div style={{
                // display: 'flex',
                // justifyContent: 'center',
                // alignItems: 'center',
                height: '100vh',
                width: '100vw',
                backgroundColor: COLOR_BACKGROUND_WHITE_CLARO,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                
            }}>
                <LogoSicoop tamano={300} />
                <LinearProgress style={{ width: '100%' }} />
            </div>

    )
}

export default SplashIcon;